// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2dxd6","large":"styles_large__2L7KF"};